import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DetailPageLayout } from "@dashboard/components/Layouts";
import { UserFragment } from "@dashboard/graphql";
import { sectionNames } from "@dashboard/intl";
import { Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, NavigationCard } from "@saleor/macaw-ui";
import { vars } from "@saleor/macaw-ui/next";
import useNotifier from "@dashboard/hooks/useNotifier";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebaseConfig";
import VersionInfo from "../components/VersionInfo";
import { MenuSection } from "./types";
import { hasUserMenuItemPermissions } from "./utils";
import { Expo } from "expo-server-sdk";
import {
  doc,
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore/lite";
import useLocale from "@dashboard/hooks/useLocale";
import { Locale } from "@dashboard/components/Locale";
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Box,
  TextField,
  Paper,
  Button,
  Container,
  CircularProgress,
  Grid,
} from "@material-ui/core";

interface VersionInfo {
  dashboardVersion: string;
  coreVersion: string;
}
let expo = new Expo({
  /*
   * @deprecated
   * The optional useFcmV1 parameter defaults to true, as FCMv1 is now the default for the Expo push service.
   *
   * If using FCMv1, the useFcmV1 parameter may be omitted.
   * Set this to false to have Expo send to the legacy endpoint.
   *
   * See https://firebase.google.com/support/faq#deprecated-api-shutdown
   * for important information on the legacy endpoint shutdown.
   *
   * Once the legacy service is fully shut down, the parameter will be removed in a future PR.
   */
  useFcmV1: true,
});
const useStyles = makeStyles(
  theme => ({
    configurationCategory: {
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "1fr",
      },
      display: "grid",
      gap: theme.spacing(4),
      gridTemplateColumns: "1fr 3fr",
      padding: theme.spacing(4, 0),
    },

    configurationItem: {
      display: "grid",
      gap: theme.spacing(4),
      gridTemplateColumns: "1fr 1fr",
    },
    configurationLabel: {
      paddingBottom: 20,
    },

    link: {
      display: "contents",
      marginBottom: theme.spacing(4),
    },
    icon: {
      "& path": {
        fill: theme.palette.primary.main,
      },
      fontSize: 48,
    },
    sectionDescription: {},
    sectionTitle: {
      fontSize: 20,
      fontWeight: 600 as 600,
    },
    navigationCard: {
      border: `1px solid ${vars.colors.border.neutralDefault}`,
      height: 130,
      boxShadow: "none !important",
      "& .MuiCardContent-root": {
        borderRadius: vars.borderRadius[3],
      },
    },
  }),
  { name: "ConfigurationPage" },
);

export interface ConfigurationPageProps {
  menu: MenuSection[];
  user: UserFragment;
  versionInfo: VersionInfo;
}

export const NotificationsPage: React.FC<ConfigurationPageProps> = props => {
  const {
    menu: menus,
    user,
    versionInfo: { dashboardVersion, coreVersion },
  } = props;
  const classes = useStyles(props);
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  const renderVersionInfo = (
    <VersionInfo
      dashboardVersion={dashboardVersion}
      coreVersion={coreVersion}
    />
  );
  const notify = useNotifier();

  const { locale } = useLocale();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const clearFields = () => {
    setTitle("");
    setContent("");
    setLink("");
  };
  const authenticateUser = async (email: string, password: string) => {
    try {
      if (auth.currentUser?.uid) {
        console.log("User already authenticated!");
        return;
      }
      await signInWithEmailAndPassword(auth, email, password);
      console.log("User authenticated successfully!");
    } catch (error) {
      console.error("Error authenticating user: ", error);
      throw error;
    }
  };
  const submit = async () => {
    try {
      setLoading(true);
      await authenticateUser(
        "mohammedfarhat1995@gmail.com",
        "zhome-notification-25",
      );
      const fcmTokensCollection = collection(db, "fcmTokens");
      const querySnapshot = await getDocs(fcmTokensCollection);
      // Loop through each document and send the Expo token
      let messages = [];
      querySnapshot.forEach(async docSnap => {
        try {
          // Send Push Notification
          const pushToken = docSnap.data().token;
          if (Expo.isExpoPushToken(pushToken)) {
            messages.push({
              to: pushToken,
              sound: "default",
              title: title,
              body: content,
              data: { url: link },
            });
          } else {
            console.warn(
              `Push token ${pushToken} is not a valid Expo push token`,
            );
          }
        } catch (err) {
          throw err;
        }
      });
      const chunkSize = 100;
      for (let i = 0; i < messages.length; i += chunkSize) {
        const chunk = messages.slice(i, i + chunkSize);
        const response = await fetch("https://exp.host/--/api/v2/push/send", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Accept-encoding": "gzip, deflate",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(chunk),
        });
        if (!response.ok) {
          throw new Error("error");
        }
        setLoading(false);
        clearFields();
        notify({
          status: "success",
          text: "Notification sent successfully",
        });
      }
    } catch (err) {
      notify({
        status: "error",
        text: "Error sending notification",
      });
      setLoading(false);
    }
  };
  return (
    <DetailPageLayout gridTemplateColumns={1} withSavebar={false}>
      <TopNav title={locale === Locale.AR ? "الاشعارات" : "Notifications"}>
        {isSmUp && renderVersionInfo}
      </TopNav>
      <Container style={{ marginTop: "20px", overflow: "hidden" }}>
        <form
          onSubmit={e => {
            e.preventDefault();
            submit();
          }}
        >
          <Grid spacing={3} container>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                required
                label={"Title"}
                fullWidth
                value={title}
                onChange={event => {
                  setTitle(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                required
                label={"Body"}
                fullWidth
                value={content}
                onChange={event => {
                  setContent(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={"URL"}
                fullWidth
                value={link}
                onChange={event => {
                  setLink(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                title="Send notification"
                disabled={loading}
              >
                {!loading ? (
                  "Send"
                ) : (
                  <CircularProgress size={20} color="inherit" />
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </DetailPageLayout>
  );
};

NotificationsPage.displayName = "NotificationsPage";
